import { baseApi } from 'shared/api/base-api';
import { OrganizersDataMapper } from 'modules/organizers/domain/data-mappers/organizers.data-mapper';
import { OrganizerInfoDto } from 'modules/organizers/domain/interfaces/organizer-dto';
import { Organizer } from 'modules/organizers/domain/interfaces/organizer';

const GET_ORGANIZER_BY_ID_QUERY = `#graphql
  query getTournamentDetails($id: Int!) {
    tournament(id: $id) {
      id
      name
      sportType
      phone
      email
      createdAt
      updatedAt
      description
      images { type externalUrl createdAt }
      address { id city country }
      adminUser {
        id name surname middleName
        createdAt updatedAt
        wallet { balanceInMinorUnits }
      }
    }
  }
`;

const organizersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getOrganizerById: build.query<Organizer, number>({
      query: (id) => ({
        query: GET_ORGANIZER_BY_ID_QUERY,
        variables: { id },
      }),
      transformResponse: (res: { tournament: OrganizerInfoDto }) =>
        new OrganizersDataMapper().decode([res.tournament])[0],
      providesTags: (_res, _err, id) => [{ type: 'Organizer', id }],
      keepUnusedDataFor: 120,
    }),
  }),
  overrideExisting: false,
});

export const { useGetOrganizerByIdQuery } = organizersApi;
